import $ from 'jquery';

const body = $('body');
const wind = $(window);
const bodyHTML = $('body, html');

let scrollPosi;

function bodyFix() {
  scrollPosi = wind.scrollTop();

  body.css({
    top: -scrollPosi,
    position: 'fixed',
    width: '100%'
  });
}

function bodyFixReset() {
  body.removeAttr('style')

  bodyHTML.scrollTop(scrollPosi);
}

wind.on('load', () => {
  const modal = $('.js-modal1')

  if (modal.length) {
    // modal.each(function () {
    //   const btn = $(this).find('[data-modal]')

    //   if (btn.length) {
    //     btn.each(function () {
    //       $(this).on('click', () => {
    //         $(`[data-modal-content=${$(this).data('modal')}]`) && $(`[data-modal-content=${$(this).data('modal')}]`).addClass('is-show')
    //         bodyFix()
    //         closeModal()
    //       })
    //     })
    //   }
    // })

    $("#js-btn-modal").on('click', () => {
      $(`[data-modal-content=mv2-modal${Math.floor(Math.random() * 3) + 1}]`) && $(`[data-modal-content=mv2-modal${Math.floor(Math.random() * 3) + 1}]`).addClass('is-show')
      bodyFix()
      closeModal()
    })
  }
})

function closeModal() {
  const btn = $('.js-close-modal1')

  if (btn.length) {
    btn.on('click', function () {
      hideModal($(this).parents('[data-modal-content]'))
    })
  }

  // wind.on('click', e => $(e.target).is('.c-modal1') && hideModal($(e.target)))
}

function hideModal(ele) {
  if (ele) {
    ele.removeClass('is-show')
    bodyFixReset()
  }
}